import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { ProductModelService } from './product-model.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-product-model',
  templateUrl: './product-model.component.html',
  styleUrls: ['./product-model.component.scss']
})
export class ProductModelComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'model','model_code', 'product_category', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  productModelForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");
  fullUserList: any[] = [];

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private productModelService: ProductModelService) {
    this.productModelForm = this.fb.group({
      model: ['', Validators.required],
      category: ['', Validators.required],
      status: ['', Validators.required],
      modelCode:['',Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCategory();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.productModelForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    console.log(this.selectedObject);
    this.productModelForm.patchValue({
      model: object.model,
      category: object?.category_id,
      status: object.status ? 1 : 0,
      modelCode:object.model_code
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const modelMatch = data.model.toLowerCase().includes(filter);
      const modelCodeMatch = data.model_code.toLowerCase().includes(filter);
      const categoryMatch = data?.product_category?.product_category.toLowerCase().includes(filter);      
      return modelMatch || modelCodeMatch || categoryMatch;
    };
      this.dataSource.filter = filterValue;
  }
  

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }
  

  create() {
    this.submitted = true
    if (this.productModelForm.valid) {
      const productModelData = this.productModelForm.value;
      let obj = {
        "model": productModelData.model,
        "category_id": productModelData.category,
        "model_code":productModelData.modelCode,
        "status": parseInt(productModelData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productModelService.productModelCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product model created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.productModelForm.valid) {
      const productModelData = this.productModelForm.value;
      let obj = {
        "model": productModelData.model,
        "category_id": productModelData.category,
        "status": parseInt(productModelData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productModelService.productModelCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product model updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.productModelForm.patchValue({
      model: '',
      category: '',
      status: '',
      modelCode:''
    });
  }


  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.productModelService.productModelCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        console.log(this.ELEMENT_DATA);
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  categoryList: any = [];
  getCategory() {
    let reqObject = {
      flag: 'list'
    }
    this.productModelService.productCategoryList(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.categoryList = responseData.data
      }
    });
  }
}
